import { useQuery } from '@apollo/client';
import { Box, IconSize } from '@bechtel/gds';
import { OperatorType, SearchInput, SearchRequisitionResult, SortType } from '@bechtel/ht-types';
import { get, map } from 'lodash';
import { FC } from 'react';
import { useParams } from 'react-router-dom';
import { AppSpinner } from '~/components/app-spinner';
import { SEARCH_REQUISITIONS } from '~/gql';
import RequisitionHistoryListItem from './list-item';
import { ReqHistoryListWrapper } from './styled';

interface RequisitionHistoryListProps {
  searchValue: string;
}

const RequisitionHistoryList: FC<RequisitionHistoryListProps> = ({ searchValue }) => {
  const params = useParams();
  const { data, loading } = useQuery<
    {
      searchRequisitions: SearchRequisitionResult;
    },
    { searchInput: SearchInput }
  >(SEARCH_REQUISITIONS, {
    variables: {
      searchInput: {
        filterInput: {
          and: [
            {
              field: 'requisitionNumber',
              operator: OperatorType.LIKE,
              value: searchValue,
            },
            {
              field: 'status',
              operator: OperatorType.EQUAL,
              value: 'SAVED',
            },
          ],
        },
        sortInput: [
          {
            field: 'updatedDate',
            sort: SortType.DESC,
          },
        ],
      },
    },
  });

  const requisitionsList = get(data, 'searchRequisitions.items', []);

  return (
    <ReqHistoryListWrapper>
      {loading && (
        <Box justifyContent={{ sm: 'center' }} alignItems={{ sm: 'center' }} p={{ sm: '500' }}>
          <AppSpinner size={IconSize.MEDIUM} />
        </Box>
      )}
      {map(requisitionsList, (requisition) => (
        <RequisitionHistoryListItem
          key={requisition.id}
          requisition={requisition}
          selected={requisition.id === params['*']}
        />
      ))}
    </ReqHistoryListWrapper>
  );
};

export default RequisitionHistoryList;
